export const THEMES = [
  {
    id: "red-blooms",
    name: "Red Blooms",
    description: "Crimson profond & roses poudrées",
    swatches: ["#7a1f2b", "#c9484f", "#f6dde0"],
  },
  {
    id: "gold-elegance",
    name: "Gold Elegance",
    description: "Ivoire & or champagne",
    swatches: ["#8a6a1f", "#b8860b", "#efe3c2"],
  },
  {
    id: "garden-colorful",
    name: "Garden Colorful",
    description: "Fleurs multicolores joyeuses",
    swatches: ["#7c3aed", "#fb7185", "#f59e0b"],
  },
  {
    id: "midnight-eucalyptus",
    name: "Midnight Eucalyptus",
    description: "Vert profond & feuillage argenté",
    swatches: ["#1f3a34", "#3f7d6e", "#dbe7e1"],
  },
] as const;

export type ThemeId = (typeof THEMES)[number]["id"];

export const THEME_IDS = THEMES.map((t) => t.id) as [ThemeId, ...ThemeId[]];

export const DEFAULT_THEME: ThemeId = "red-blooms";

export function isThemeId(value: string): value is ThemeId {
  return THEMES.some((t) => t.id === value);
}

export function themeName(id: string): string {
  return THEMES.find((t) => t.id === id)?.name ?? THEMES[0].name;
}
